import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiWrapperTableCellBase } from '../fi-wrapper-table-cell-base';

@Component({
    selector: 'fi-wrapper-table-html-cell',
    template: `<div class="html-cell-content" [fiBindHtmlCompile]="value"></div>`,
    styleUrls: ['./fi-wrapper-table-html-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-wrapper-table-html-cell' },
    standalone: false,
})
export class FiWrapperTableHtmlCellComponent extends FiWrapperTableCellBase<string> {}
